import type { Provider, Type } from '@angular/core';
import { InjectionToken } from '@angular/core';

import type { DataSource, ViewRecord, ViewRecordData } from '@recruitee/views-types';

import type { DataTransform } from './layout-tokens';

export interface LayoutListHeaderComponent<T extends ViewRecord> {
  recordData: ViewRecordData<T>;
  isCollapsed: boolean;
}

export interface LayoutListRowComponent<T extends ViewRecord> {
  record: T;
  fieldsVisibilityMap: Record<string, boolean>;
}

export interface LayoutListConfig<From extends ViewRecord, To extends ViewRecord = From> {
  header: Type<LayoutListHeaderComponent<ViewRecord>>;
  record: Type<LayoutListRowComponent<ViewRecord>>;
  recordsTransform?: new () => DataTransform<From, To>;
}

export type ListComponentMap = {
  [k in DataSource['id']]?: LayoutListConfig<ViewRecord>;
};

export const LIST_CONFIG_MAP = new InjectionToken<ListComponentMap>('LIST_ITEM');
export const provideListLayout = (listComponentMap: ListComponentMap): Provider[] => [
  { provide: LIST_CONFIG_MAP, useValue: listComponentMap },
];
